import { BehaviorSubject, Subject } from 'rxjs';
import { USER_ROLE } from '../helpers/helper-users.js';
export function isMapPOIModalOptions(options) {
    return (options.type === 'sightseeing' ||
        options.type === 'place' ||
        options.type === 'details');
}
export const modal$ = new BehaviorSubject(undefined);
export const bottomSheet$ = new BehaviorSubject(undefined);
export const season$ = new BehaviorSubject('summer');
export const disableMapKvp$ = new BehaviorSubject(true);
export const filterDirty$ = new BehaviorSubject(false);
export const maintenanceStatus$ = new BehaviorSubject({
    logindisabled: false,
    showloginmsg: false,
});
export const userStatus$ = new BehaviorSubject(USER_ROLE.notLogged);
export const updateChosenFilters$ = new Subject();
export const urlSearchParamsChanged$ = new BehaviorSubject(new URLSearchParams());
export const bigGalleryIndexChange$ = new Subject();
export const disableMapAnimation$ = new BehaviorSubject(false);
export const disableMainPageAnimation$ = new BehaviorSubject(false);
export const adminMessageShown$ = new BehaviorSubject(false);
export const adminMessageLoaded$ = new BehaviorSubject(false);
export const rememberListView$ = new BehaviorSubject(false);
export const rememberFilterView$ = new BehaviorSubject(false);
export const rememberScrollPosition$ = new BehaviorSubject(undefined);
export const stpShortTitles$ = new BehaviorSubject(undefined);
export const activeFocusGallery$ = new BehaviorSubject(undefined);
export const llmFeedbackSpanID$ = new BehaviorSubject(null);
export const llmFeedbackSent$ = new BehaviorSubject(null);
//# sourceMappingURL=store-main.js.map